import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink'
import { cleanBrandTitle } from '../../utils/cleanBrandTitle'
import { replaceTags } from '../../utils/replaceTags'
import { unescapeTags } from '@aytm/lib/common/func'
import { IEcommerceAnswerSchema } from '../../types'
import style from './CardHeader.module.scss'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'

type CardAboutProps = {
  schema: IEcommerceAnswerSchema
}

const CardAbout = ({ schema }: CardAboutProps) => {
  const { t } = useSurveyLocale()
  // schema allows dimensions to be nil, and unvalidated entries can miss name/value or hold non-strings
  const dimensions = (schema.dimensions || []).filter(dimension =>
    [dimension?.name, dimension?.value].every(v => typeof v === 'string' && v)
  )

  return (
    <div className={style.cardAbout}>
      <div className={style.productDetails}>{t('questions', 'ec', 'amazon', 'productDetails')}</div>
      <div className={style.infoTitleContainer}>
        <span className={style.infoTitle}>{t('questions', 'ec', 'amazon', 'topHighlights')}</span>
        <EmptyLink>
          <i className="pi pi-chevron-up" />
        </EmptyLink>
      </div>
      <div className={style.infoTable} data-testid="SW-SH-TopHighlights">
        {schema.sub_title && (
          <div className={style.infoTableRow}>
            <div className={style.tableTitleCell}>{t('questions', 'ec', 'amazon', 'brand')}</div>
            <div className={style.tableValueCell}>{cleanBrandTitle(unescapeTags(schema.sub_title) as string)}</div>
          </div>
        )}
        {dimensions.length > 0 && (
          <>
            {dimensions.map(({ name, value }, index) => (
              <div className={style.infoTableRow} key={index}>
                <div className={style.tableTitleCell}>{name}</div>
                <div className={style.tableValueCell}>{value}</div>
              </div>
            ))}
          </>
        )}
      </div>
      <div className={style.infoTitleContainer}>
        <span className={style.infoTitle}>{t('questions', 'ec', 'amazon', 'aboutItem')}</span>
        <EmptyLink>
          <i className="pi pi-chevron-up" />
        </EmptyLink>
      </div>
      {schema.description && (
        <span
          className={style.base}
          dangerouslySetInnerHTML={{
            __html: replaceTags(schema.description)
          }}
        />
      )}
      {schema.feature_bullets && (
        <span
          className={style.base}
          dangerouslySetInnerHTML={{
            __html: replaceTags(schema.feature_bullets)
          }}
        />
      )}

      <div className={style.infoTitleContainer}>
        <span className={style.infoTitle}>{t('questions', 'ec', 'amazon', 'productSpecifications')}</span>
        <EmptyLink>
          <i className="pi pi-chevron-down" />
        </EmptyLink>
      </div>
      <div className={style.infoTitleContainer}>
        <span className={style.infoTitle}>{t('questions', 'ec', 'amazon', 'aboutBrand')}</span>
        <EmptyLink>
          <i className="pi pi-chevron-down" />
        </EmptyLink>
      </div>
    </div>
  )
}

export default CardAbout
